import styled, { keyframes } from 'styled-components'

import { rspTheme } from '../../styles/rspTheme'

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`

const fadeInWithZoom = keyframes`
  0% {
    transform: scale(1.2);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
`

const fadeOut = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`

export const SlideContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  /* min-height: 620px; */
  max-height: 900px;
  width: 100%;
  max-width: 1680px;
  margin: 0 auto;
  text-align: left;

  &.dark {
    color: #ffffff;
  }

  &.light {
    color: ${rspTheme.palette.primary.main};
  }

  &.technology {
    .slideBody {
      color: white;
      max-width: 40ch;
      @media screen and (max-width: ${rspTheme.breakpoints.values.smmd}px) {
        max-width: 32ch;
      }
    }
    .featureImageContainer {
      max-width: 950px;
      max-height: 450px;
      margin: 0 auto;
      @media screen and (max-width: ${rspTheme.breakpoints.values.smmd}px) {
        max-width: 400px;
        max-height: 400px;
      }
    }
    .impactGrid {
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
      justify-content: center;
    }
  }

  &.firstHeroSlide {
    animation: ${fadeOut} 0.15s ease-in-out forwards;
    animation-iteration-count: 1;

    .featureImageContainer.heroSlideImage {
      animation-delay: 0.15s;
    }

    &.slideActive {
      animation: ${fadeIn} 0.25s ease-in-out forwards;
    }
  }

  .heroSlideImage .gatsby-image-wrapper {
    max-width: 360px;
  }

  .featureImageContainer {
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;

    &.heroSlideImage {
      max-width: 360px;

      @media (max-width: 980px) {
        max-height: 350px;
        .gatsby-image-wrapper {
          img {
            height: 100%;
            object-fit: contain !important;
          }
        }
      }
    }

    &.heroSlideInitialImage {
      max-width: 400px;
      margin: 0 auto;
    }
  }

  .impactStatContainer {
    align-self: stretch;
    background-image: radial-gradient(50% 50% at 50% 50%, #524677, transparent);
    display: flex;
    align-items: center;
    justify-content: center;

    .stat {
      font-size: 18rem;
      font-weight: 600;
      text-align: center;
      line-height: 1;
      background-image: linear-gradient(${rspTheme.gradient});
      -webkit-background-clip: text;
      -moz-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      -moz-text-fill-color: transparent;
      text-fill-color: transparent;
    }

    @media (max-width: ${rspTheme.breakpoints.values.smmd}px) {
      min-height: 330px;
      margin-top: 24px;

      .stat {
        font-size: 10rem;
      }
    }
  }

  .heroCaption {
    color: ${rspTheme.palette.text.disabled};
    text-transform: uppercase;
    text-align: center;
    grid-column: 2;
    margin: 56px 0 0 0;

    @media (max-width: ${rspTheme.breakpoints.values.smmd}px) {
      margin: 20px 0;
    }
  }

  .contentContainer,
  .backgroundImage,
  .impactStatContainer,
  .featureImageContainer {
    opacity: 0;
    transform-origin: center;
    animation: ${fadeOut} 0.5s ease-in-out;
    animation-iteration-count: 1;
    @media screen and (max-width: 980px) {
      max-width: 100%;
    }
  }

  &.slideActive {
    z-index: 20;

    .contentContainer {
      animation: ${fadeIn} 0.65s ease-in-out forwards;
    }
    .backgroundImage,
    .impactStatContainer,
    .featureImageContainer {
      animation: ${fadeInWithZoom} 0.65s ease-in-out forwards;
      @media screen and (max-width: 980px) {
        max-width: 100%;
      }
      @media screen and (max-width: 768px) {
        margin-top: 120px;
      }
    }
  }

  & .backgroundImage {
    grid-row: 1 / -1;
    grid-column: 1 / -1;
    width: 100%;
    height: 100%;

    .gatsby-image-wrapper {
      width: 100%;
      height: 100%;

      img {
        object-position: top center;

        @media (max-width: ${rspTheme.breakpoints.values.smmd}px) {
          object-position: 70%;
        }
      }

      &.hasMobileImage {
        @media (max-width: ${rspTheme.breakpoints.values.smmd}px) {
          img {
            object-position: center center;
          }
        }
      }
    }
  }
`

export const BackgroundGradient = styled.div`
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  width: 100%;
  height: 100%;
  display: none;
  z-index: 5;

  &.darkTheme {
    background-image: linear-gradient(
      to top,
      rgba(33, 21, 74, 0.9) 10%,
      transparent 80%
    );
  }

  &.lightTheme {
    background-image: linear-gradient(
      to top,
      rgba(255, 255, 255, 0.8) 10%,
      transparent 70%
    );
  }

  @media (max-width: ${rspTheme.breakpoints.values.md}px) {
    display: block;
  }
`

export const ContentContainer = styled.div`
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  align-self: center;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 64px 0 96px;

  @media (max-width: 981px) {
    padding: 90px 0 96px;
  }

  &.heroTrainstopContent {
    .contentContainer {
      padding-bottom: 0;
      @media (min-width: 769px) and (max-width: 980px) {
        padding-bottom: 96px;
      }
    }
  }

  .heroGrid {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 16px;

    @media (max-width: 980px) {
      display: block;
    }
  }

  .heroSlideCtaContainer {
    margin-top: 2.8rem;

    @media (max-width: 980px) {
      margin-top: 0;
    }
  }

  .heroSlideSubhead {
    color: ${rspTheme.palette.primary.main};
    margin-bottom: 2.1rem;

    &.dark {
      color: #ffffff;
    }
  }

  .heroSlideBody {
    color: ${rspTheme.palette.text.primary};
    font-size: 1.8rem;
    line-height: 1.35;

    &.dark {
      color: #ffffff;
    }

    @media (max-width: 980px) {
      font-size: 1.6rem;
      padding-bottom: 2.1rem;
    }
  }

  .contentGrid {
    display: flex;
    height: 100%;
    max-height: 275px;
    gap: 24px;

    > div {
      width: 50%;
      flex-shrink: 1;
      flex-grow: 1;
    }

    @media (max-width: 980px) {
      flex-direction: column;
      max-height: unset;
      justify-content: center;
      align-items: center;

      > div {
        width: 100%;
      }
    }
  }

  &.impactContent {
    align-self: stretch;
    @media (max-width: ${rspTheme.breakpoints.values.smmd}px) {
      align-self: start;
      padding: 88px 0;
    }
  }

  .impactWrapper {
    height: 100%;
  }

  .impactGrid {
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-template-rows: 1fr;
    align-items: center;

    @media (max-width: ${rspTheme.breakpoints.values.smmd}px) {
      grid-template-columns: 1fr;
    }
  }

  .slideSubhead {
    color: inherit;
    font-size: 1.6rem;
    font-weight: 400;
    text-transform: uppercase;
    margin-bottom: 16px;
    display: none;

    @media (max-width: ${rspTheme.breakpoints.values.smmd}px) {
      display: block;
    }
  }

  .slideBody {
    color: inherit;
    max-width: 26ch;

    + * {
      margin-top: 32px;
    }

    @media (max-width: ${rspTheme.breakpoints.values.smmd}px) {
      max-width: unset;
    }
  }

  @media (max-width: ${rspTheme.breakpoints.values.smmd}px) {
    align-self: end;
    padding: 0 0 84px;
  }
`
